/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Name_ColInputs */

const en_admin_roles_name_col = /** @type {(inputs: Admin_Roles_Name_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const zh_admin_roles_name_col = /** @type {(inputs: Admin_Roles_Name_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Admin_Roles_Name_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_name_col = /** @type {((inputs?: Admin_Roles_Name_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Name_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_name_col(inputs)
	return zh_admin_roles_name_col(inputs)
});
export { admin_roles_name_col as "admin.roles.name_col" }